import React from "react"
import { Illustration } from "./Illustration"

const AccessDenied: React.FC = () => {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center gap-2 p-4">
      <Illustration name="user-empty" />
      <h1 className="margin-top-4 text-error text-heading-md">Access Denied</h1>
      <p className="text-on-surface-variant margin-top-4 max-w-md text-center">
        Sorry, you do not have permission to view this page. Please contact your
        administrator if you believe this is a mistake.
      </p>
    </div>
  )
}

export default AccessDenied
